module.exports = global["dc"] = require("-!/Users/uyangaganbaatar/Desktop/mapd-charting/node_modules/babel-loader/lib/index.js!./index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?dc!./src/index.js-exposed
// module id = 515
// module chunks = 0